import { Team } from '../../models/Team';

const serializeTeam = ({ createdAt, ...rest }: Team): Team => ({
  ...(createdAt && { createdAt: new Date(createdAt) }),
  ...rest,
});

export default serializeTeam;
